import React from 'react'

const Close = () => <svg className="nav-icon" style={{ height: "inherit" }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M28.2 24L41 11.3c1.2-1.2 1.2-3.1 0-4.2-1.2-1.2-3.1-1.2-4.2 0L24 19.8 11.3 7C10.1 5.9 8.2 5.9 7 7c-1.2 1.2-1.2 3.1 0 4.2L19.8 24 7 36.7c-1.2 1.2-1.2 3.1 0 4.2 1.2 1.2 3.1 1.2 4.2 0L24 28.2 36.7 41c1.2 1.2 3.1 1.2 4.2 0 1.2-1.2 1.2-3.1 0-4.2L28.2 24z"/></svg>

export default Close